import React from 'react';

import {PageWrapperLayout} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {getPageHeaderTitle} from 'presentation/utils';

const {
	title,
	locationSelection: {city, state},
	changePassword,
} = translations['pt-br'].privateFlow.profile;

const {changePlan} = translations['pt-br'].privateFlow.accountRegister;

const pathTitle: Record<string, string> = {
	estado: state.pageTitle,
	cidade: city.pageTitle,
	plano: changePlan,
	'alterar-senha': changePassword.title,
	'compartilhamento-de-dados': 'Gerenciar acessos',
	funcionalidades: 'Funcionalidades',
};

export function ProfileWrapper() {
	const pageTitle = getPageHeaderTitle({internalPaths: pathTitle, mainPath: title});

	return <PageWrapperLayout title={pageTitle} />;
}
